<template>
  <div class="min-h-screen h-full overflow-hidden" style="height:145px">
    <div class="home rd-bg h-full" :style="{ backgroundColor: bgColor }">
      <div class="flex items-center h-full w-full">
        <div class="rd-carousel--wrapper w-full relative text-center">

          <div class="rd-logo flex justify-center mb-12">
            <img v-if="rdLogo === 'dark'" src="https://reviewdrop.io/storage/site/email/reviewdrop-email-blk.png"
              alt="Reviewdrop Reviews Widget" class="max-w-sm">
            <img v-else src="https://reviewdrop.io/storage/site/email/reviewdrop-email.png"
              alt="Reviewdrop Reviews Widget" class="max-w-sm">
          </div>

          <VueSlickCarousel v-bind="settings" v-if="!isLoading && posts.length" :arrows="true"
            :class="{ 'arrows-light': arrowColors }" :dots="false" :slidesToShow="3" :slidesToScroll="3">
            <div class="slide outline-none h-full" v-for="post in posts" :key="post.id">
              <div class="mx-2 sm:mx-6 p-6 sm:p-8 h-full flex flex-col flex-1" :style="{ backgroundColor: bgReview }">

                <div v-if="post.order && verifiedNotice == 'true'"
                  class="flex items-center mb-2 justify-center opacity-80 text-sm text-blue-500"
                  content="Review invitation sent after order." v-tippy="{ arrow: true, animation: 'fade' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="h-4 w-4 mr-1"
                    fill="currentColor">
                    <path
                      d="M4.035 15.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479zm1.442-5.403 1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848l-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848z">
                    </path>
                    <path d="m15.742 10.71-1.408-1.42-3.331 3.299-1.296-1.296-1.414 1.414 2.704 2.704z"></path>
                  </svg> Verified Review
                </div>
                <div class="h-full flex flex-col justify-center text-center">
                  <p class="hidden xl:block text-base clamp-text" :style="{ color: bodyColor }">
                    {{ post.content | truncate(200, "") }}
                  </p>
                  <p class="block xl:hidden text-base clamp-text-mob" :style="{ color: bodyColor }">
                    {{ post.content | truncate(200, "") }}
                  </p>
                </div>
                <div class="flex flex-col justify-center items-center pt-4 xl:pt-4 mt-auto">
                  <a :href="'https://reviewdrop.io/reviews/' + post.id" target="_blank">
                    <div class="
                    flex
                    items-center
                    text-xs
                    md:text-sm
                    uppercase
                    tracking-wide
                    font-semibold
                    italic
                  ">
                      <span :style="{ color: bodyColor }">{{ post.name || '&nbsp;' }}</span>
                    </div>
                  </a>

                  

                  <div class="flex items-center justify-center mt-2 text-base h-auto">

                    <div class="rd-star-ratings" v-for="index in post.rating" :key="index">
                      <svg xmlns="http://www.w3.org/2000/svg" :style="{ fill: starColor }" viewBox="0 0 20 20"
                        class="w-4 h-4">
                        <path fill-rule="evenodd"
                          d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                          clip-rule="evenodd" />
                      </svg>
                    </div>

                    <form class="order-1 relative top-[0.2rem] hidden">
                      <div class="rating">
                        <input class="star star-5" id="star-5" type="radio" :name="post.id" value="5"
                          :checked="post.rating == 5" disabled />
                        <label class="star star-5" for="star-5"></label>
                        <input class="star star-4" id="star-4" type="radio" :name="post.id" value="4"
                          :checked="post.rating == 4" disabled />
                        <label class="star star-4" for="star-4"></label>
                        <input class="star star-3" id="star-3" type="radio" :name="post.id" value="3"
                          :checked="post.rating == 3" disabled />
                        <label class="star star-3" for="star-3"></label>
                        <input class="star star-2" id="star-2" type="radio" :name="post.id" value="2"
                          :checked="post.rating == 2" disabled />
                        <label class="star star-2" for="star-2"></label>
                        <input class="star star-1" id="star-1" type="radio" :name="post.id" value="1"
                          :checked="post.rating == 1" disabled />
                        <label class="star star-1" for="star-1"></label>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>

          <div class="mt-12">
            <a v-bind:href="'https://reviewdrop.io/review/' + author" target="_blank"
              class="font-medium text-base underline" :style="{ color: reviewsLink }">
              View all reviews
            </a>
          </div>

          <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" :opacity="1"></loading>
        </div>
      </div>

      <!-- end of post grid -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
// import $ from "jquery-slim";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Home",
  components: {
    Loading,
    VueSlickCarousel,
  },
  data() {
    return {
      isLoading: false,
      page: 0,
      fullPage: true,
      posts: [],
      show: true,
      totalPages: "",
      bgColor: "#FFF",
      starColor: "#F4BA4A",
      bodyColor: "#5F5F5F",
      reviewsLink: "#5f5f5f",
      bgReview: "#f9f9f9",
      verifiedNotice: true,
      rdLogo: 'dark',
      borderColor: "",
      currentAuthor: "",
      name: "",
      author: "",
      arrowColors: false,
      apiURL: "https://reviewdrop.io/api/reviews/",
      apiUsr: "https://reviewdrop.io/api/user/",
      totalReviews: 0,
      profileRating: 1,
      settings: {
        dots: false,
        infinite: true,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ],
      },
    };
  },
  mounted() {
    let q = this.$router.currentRoute.query;
    // console.log(q);
    if (q.bgColor) {
      this.bgColor = "#" + q.bgColor;
    }

    if (q.starColor) {
      this.starColor = "#" + q.starColor;
    }

    if (q.bodyColor) {
      this.bodyColor = "#" + q.bodyColor;
    }

    if (q.bgReview) {
      this.bgReview = "#" + q.bgReview;
    }

    if (q.verifiedNotice) {
      this.verifiedNotice = q.verifiedNotice;
    }

    if (q.reviewsLink) {
      this.reviewsLink = "#" + q.reviewsLink;
    }

    if (q.rdLogo) {
      this.rdLogo = q.rdLogo;
    }

    if (q.arrows) {

      if (q.arrows === 'true') {
        this.arrowColors = true;
      } else {
        this.arrowColors = false;
      }

    }

    this.borderColor = q.borderColor;
    this.currentAuthor = q.currentAuthor;


    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        let message = {
          height: document.body.scrollHeight,
          width: document.body.scrollWidth,
        };

        // window.top refers to parent window
        window.top.postMessage(message, "*");
      }
    };

    this.getPosts();
    this.getAuthor();
  },
  methods: {
    getPosts: function () {
      var self = this;
      self.page++;
      this.isLoading = true;
      axios
        .get(self.apiURL + self.currentAuthor + "?page=" + self.page)
        .then(function (response) {
          let reviewHeader = response.headers["x-review-total"];
          self.totalPages = reviewHeader;
          if (self.page >= self.totalPages) {
            self.show = false;
          }
          var datas = response.data;

          datas.forEach(function (element) {
            self.posts.push(element);
          });
          self.isLoading = false;
        });
    },

    getAuthor: function () {
      let self = this;
      axios.get(self.apiUsr + self.currentAuthor).then(function (response) {
        var author = response.data;
        self.author = author.id;
        self.name = author.name;
        self.totalReviews = author.review_count;
        self.profileRating = author.rating;
      });
    },
  },
};
</script>
